import { useCallback, useEffect, useState } from 'react';
import {
  loadPendingUnionRegistrations,
  reviewUnionRegistration,
} from '../api/platformUnionReviewApi.js';

export function usePlatformUnionReview() {
  const [isPlatformAdmin, setIsPlatformAdmin] = useState(false);
  const [isFullAdmin, setIsFullAdmin] = useState(false);
  const [applications, setApplications] = useState([]);
  const [loading, setLoading] = useState(true);
  const [actionUnionId, setActionUnionId] = useState('');
  const [notice, setNotice] = useState({ type: '', message: '' });

  const refresh = useCallback(async ({ preserveSuccess = false } = {}) => {
    setLoading(true);

    try {
      const result = await loadPendingUnionRegistrations();
      setIsPlatformAdmin(result.isPlatformAdmin);
      setIsFullAdmin(result.isFullAdmin);
      setApplications(result.applications);
      if (!preserveSuccess) setNotice({ type: '', message: '' });
    } catch (error) {
      setNotice({
        type: 'error',
        message: error instanceof Error ? error.message : '승인 대기 유니온을 불러오지 못했습니다.',
      });
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    let active = true;

    loadPendingUnionRegistrations()
      .then((result) => {
        if (!active) return;
        setIsPlatformAdmin(result.isPlatformAdmin);
      setIsFullAdmin(result.isFullAdmin);
        setApplications(result.applications);
      })
      .catch((error) => {
        if (!active) return;
        setNotice({
          type: 'error',
          message: error instanceof Error ? error.message : '승인 대기 유니온을 불러오지 못했습니다.',
        });
      })
      .finally(() => {
        if (active) setLoading(false);
      });

    return () => {
      active = false;
    };
  }, []);

  const review = useCallback(async ({ unionId, unionName, approve, rejectionReason = '' }) => {
    if (!unionId || actionUnionId) return;

    setActionUnionId(unionId);
    setNotice({ type: '', message: '' });

    try {
      await reviewUnionRegistration({ unionId, approve, rejectionReason });
      const result = await loadPendingUnionRegistrations();
      setIsPlatformAdmin(result.isPlatformAdmin);
      setIsFullAdmin(result.isFullAdmin);
      setApplications(result.applications);
      setNotice({
        type: 'success',
        message: `${unionName || '유니온'} 등록을 ${approve ? '승인' : '거절'}했습니다.`,
      });
      window.dispatchEvent(new CustomEvent('dororaid:union-registration-changed'));
    } catch (error) {
      setNotice({
        type: 'error',
        message: error instanceof Error ? error.message : '유니온 등록 심사에 실패했습니다.',
      });
    } finally {
      setActionUnionId('');
    }
  }, [actionUnionId]);

  return {
    isPlatformAdmin,
    isFullAdmin,
    applications,
    loading,
    actionUnionId,
    notice,
    refresh,
    review,
  };
}
